// -*- coding: utf-8 -*-
import React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function ChatHeader({ title, info, palette, onBack, sticky = false, variant = 'desktop' }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: variant === 'mobile' ? 1 : 0,
        py: variant === 'mobile' ? 1 : 0,
        bgcolor: palette ? palette.CHAT_BG : undefined,
        borderBottom: variant === 'mobile' ? '1px solid' : undefined,
        borderColor: variant === 'mobile' ? 'divider' : undefined,
        position: sticky ? 'sticky' : 'static',
        top: 0,
        zIndex: sticky ? 2 : undefined,
      }}
    >
      {onBack && (
        <IconButton aria-label="Geri" onClick={onBack} size="small" sx={{ color: palette ? palette.TEXT : undefined }}>
          <ArrowBackIcon />
        </IconButton>
      )}
      <Typography variant={variant === 'mobile' ? 'subtitle1' : 'subtitle1'} sx={{ fontWeight: 600, color: palette ? palette.TEXT : undefined }}>
        {title}
      </Typography>
      <Box sx={{ flex: 1 }} />
      {info && (
        <Typography variant="caption" sx={{ color: palette ? palette.TIMESTAMP : 'text.secondary' }}>
          {info}
        </Typography>
      )}
    </Box>
  );
}
